<template>
  <div id="layout" :style="textStyle">
    <SiteLoader
      @setLoaderFinished="setLoaderFinished"
      :barLoader="false"
      v-if="!loaderFinished || !global.loadedItems.mainPage || !global.loadedItems.collections || !global.loadedItems.images || !global.loadedItems.fonts"
    />
    <div v-else>
      <transition name="slide" mode="out-in">
        <router-view />
      </transition>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import MainPage from "@/components/sections/MainPage/MainPage";
import SiteLoader from "@/components/global/SiteLoader";

export default {
  name: "Layout",
  components: {
    MainPage,
    SiteLoader
  },
  computed: {
    ...mapState(["global"]),
    mainFontColor(){
      return `--main_font: ${this.$store.getters.themeSettings.main_font_color};`;
    },
    secondaryFontColor(){
      return `--secondary_font: ${this.$store.getters.themeSettings.secondary_font_color};`;
    },
    hyperlinkColor(){
      return `--hyperlink_font: ${this.$store.getters.themeSettings.hyperlink_color};`;
    },
    textStyle() {
      return `${this.mainFontColor} ${this.secondaryFontColor} ${this.hyperlinkColor}`;
    },
  },
  data() {
    return {
      loaderFinished: false
    };
  },
  mounted() {
    if (this.$route.path === "/") {
      this.setPrevRouteExists(true);
    }
    if (
      this.$route.params.presentationId &&
      this.$route.params.presentationId.toString()
    ) {
      this.fetchPresentation(this.$route.params.presentationId.toString());
    } else {
      this.fetchMainPage();
    }
    // if (!window.matchMedia("(hover: none)").matches) {
    // }
    if ("ontouchstart" in document.documentElement) {
      document.getElementById("layout").classList.add("no-hover");
    } else {
      document.getElementById("layout").classList.add("can-hover");
    }
    this.fetchFooter();
  },
  methods: {
    setLoaderFinished() {
      this.loaderFinished = true;
    },
    ...mapActions(["fetchMainPage", "fetchPresentation", "setPrevRouteExists", "fetchFooter"])
  }
};
</script>

<style lang="scss">
#layout{
  a{
    transition: all 0.25s ease-in-out;
    &:hover {
        color: var(--hyperlink_font)!important;
        .title{
          color: var(--hyperlink_font);
        }
      }
  }
}
</style>

